














import { Component, Vue } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import { getLot, postLot, patchLot, getProgram } from '../api/api';
import Company from '../models/Company';
import moment from 'moment';
import Lot from '../models/Lot';
import Program from '@/models/Program';
import get from 'lodash/get';
import { typesArr, types2Arr } from '@/data/types';
import router from '@/router';
import { Route } from 'vue-router';

let lot: Lot | null = null;

async function getProgramForRouter(programID: string) {
    try {
        const { data } = await getProgram(+programID);
        return data;
    } catch (error) {
        console.warn(error, get(error, 'response.data.message'));
        return null;
    }
}

async function getLotForRouter(lotID: string) {
    try {
        const { data } = await getLot(+lotID);
        return data;
    } catch (error) {
        return null;
    }
}

function getProgramName(value: Program | null) {
    if (value) {
        return value.name;
    }
    return null;
}

function getLotName(value: Lot | null) {
    if (value) {
        return value.name;
    }
    return null;
}

async function computeBreadcrumb(to: Route, from: Route, next: Function) {
    const { route } = router.resolve({
        name: 'programs',
    });
    to.meta.breadcrumb[1].url = route.fullPath;

    const { route: routebis } = router.resolve({
        name: 'showProgram',
        params: {
            programID: to.params.programID,
        },
    });
    to.meta.breadcrumb[2].url = routebis.fullPath;

    if (to.params.programID) {
        const program = await getProgramForRouter(to.params.programID);

        if (program == null) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Programme introuvable.`,
            });

            next({
                name: 'programs',
            });
            return;
        } else {
            to.meta.breadcrumb[2].title = getProgramName(program);
        }
    }

    if (to.params.lotID) {
        lot = await getLotForRouter(to.params.lotID);

        if (lot == null) {
            Vue.prototype.$vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Lot introuvable.`,
            });

            next({
                name: 'showProgram',
                params: { programID: to.params.programID },
            });
            return;
        } else {
            to.meta.breadcrumb[3].title = getLotName(lot);
        }
    }

    next();
}

@Component({
    beforeRouteEnter: computeBreadcrumb,
    beforeRouteUpdate: computeBreadcrumb,
    components: {
        Forms,
    },
})
export default class LotForm extends Vue {
    error: string | null = null;
    type: 'edit' | 'add' | null = null;
    lot: Lot | null = lot;
    loading: boolean = false;
    errors: any = {};
    get items() {
        return [
            {
                name: 'building',
                label: 'Bâtiment',
            },
            {
                name: 'name',
                label: 'N° lot *',
                type: 'text',
                errorMessage: 'Le n° du lot est requis',
                required: true,
            },
            {
                name: 'year_construction',
                label: 'Année de construction',
                type: 'date',
            },
            {
                name: 'floor',
                label: 'Niveau *',
                type: 'text',
                placeholder: 'Doit être RDC, RDJ, R-2, R-1, R+1, R+2, etc.',
                errorMessage: `Le niveau est obligatoire`,
                required: true,
            },
            {
                name: 'type',
                label: 'Type *',
                type: 'select',
                errorMessage: 'Le type est requis',
                required: true,
                items: typesArr,
            },
            {
                name: 'type2',
                label: 'Type 2 *',
                type: 'select',
                errorMessage: 'Le type 2 est requis',
                required: true,
                placeholder: types2Arr.map(x => x.value).join(', '),
                items: types2Arr,
            },
            {
                name: 'status',
                label: 'Statut *',
                type: 'select',
                required: true,
                errorMessage: 'Le status est requis',
                items: [
                    { text: 'Libre', value: 'available' },
                    { text: 'Optionné', value: 'optionned' },
                    { text: 'Réservé', value: 'booked' },
                    { text: 'Acté', value: 'acted' },
                    { text: 'NC', value: 'nc' },
                ],
            },
            {
                name: 'exposure',
                label: 'Exposition',
                type: 'text',
            },
            {
                name: 'surface_carrez',
                label: 'Surface habitable hauteur plus 1,8 m (en m²) *',
                type: 'number',
                required: true,
                errorMessage:
                    'La surface habitable hauteur plus 1,8 m est requise',
            },
            {
                name: 'surface_no_carrez',
                label: 'Surface habitable  hauteur inférieure à 1,8 m (en m²)',
                type: 'text',
            },
            {
                name: 'surface_terrace',
                label: 'Surface Balcon-Loggia Terrasse (m²)',
                type: 'number',
            },
            {
                name: 'surface_terrace_varangue',
                label: 'Surface Terrasse Varangue (m²)',
                type: 'number',
                min: 0,
            },
            {
                name: 'surface_copro_garden',
                label: 'Surface Jardin en copro (m²)',
                type: 'number',
            },
            {
                name: 'surface_land',
                label: 'Surface terrain (m²)',
                type: 'number',
            },
            {
                name: 'rent_limit_pk_included',
                label: 'Plafond LOYER Jeanbrun/denormandie',
                type: 'number',
            },
            {
                name: 'rent_limit_pk_alone',
                label: 'Plafond loyer PK seul',
                type: 'number',
            },
            {
                name: 'rent_limit_lgt_alone',
                label: 'Plafond LOYER MARCHE',
                type: 'number',
            },
            {
                name: 'price',
                label: 'Prix TTC TVA 20% (et TVA 8,5% Pour Outre-Mer)',
                type: 'number',
                required: false,
            },
            {
                name: 'price_reduced_brs',
                label: 'Prix BRS (TVA 5.5%)',
                type: 'number',
                required: false,
            },
            {
                name: 'price_reduced_lli',
                label: 'Prix LLI (Tva 10%)',
                type: 'number',
                required: false,
            },
            {
                name: 'prix_nue_propriete',
                label: 'Prix Nue-Proprieté',
                type: 'number',
                required: false,
            },
            {
                name: 'price_vat_reduce_or_controlled',
                label: 'Prix TTC TVA réduite / Prix maîtrisé',
                type: 'number',
                required: false,
            },
            {
                name: 'amount_property',
                label: 'Montant du foncier hors travaux (terrain ou plateau) en TTC',
                type: 'number',
            },
            {
                name: 'amount_work',
                label: 'Montant travaux hors foncier en TTC',
                type: 'number',
            },
            {
                name: 'amount_work_no_defisc',
                label: 'Montant travaux hors défisc en TTC',
                type: 'number',
            },
            {
                name: 'price_parking',
                label: 'Dont prix total TTC tous les Pk',
                type: 'number',
            },
            {
                name: 'price_parking_reduced_vat',
                label: 'Prix total Pk TVA Réduite/Prix maitrisé',
                type: 'number',
            },
            {
                name: 'selling_fee',
                label: 'Honoraires commercialisation en HT',
                type: 'number',
            },
            {
                name: 'location_amount_property',
                label: 'LMNP/LMP Prix total HT',
                type: 'number',
            },
            {
                name: 'location_amount_furniture',
                label: 'LMNP/LMP dont montant mobilier HT',
                type: 'number',
            },
            {
                name: 'location_amount_vat_back',
                label: 'LMNP/LMP montant Tva Récup.',
                type: 'number',
            },
            {
                name: 'rent_for_resseling',
                label: 'Montant LOYER ANNUEL ACTUEL TTC HORS CHARGES COPRO',
                type: 'number',
            },
            {
                name: 'name_parking1',
                label: 'Annexe 1',
                type: 'text',
            },
            {
                name: 'cat_parking1',
                label: 'Catégorie Annexe 1',
                type: 'text',
            },
            {
                name: 'name_parking2',
                label: 'Annexe 2',
                type: 'text',
            },
            {
                name: 'cat_parking2',
                label: 'Catégorie Annexe 2',
                type: 'text',
            },
            {
                name: 'name_parking3',
                label: 'Annexe 3',
                type: 'text',
            },
            {
                name: 'cat_parking3',
                label: 'Catégorie Annexe 3',
                type: 'text',
            },
            {
                name: 'rent_limit_pinel',
                label: 'Plafond loyer Jeanbrun/denormandie',
                type: 'number',
            },
            {
                name: 'rent_limit_market',
                label: 'Plafond loyer marché',
                type: 'number',
            },
            {
                name: 'current_rent',
                label: 'Loyer actuel',
                type: 'number',
            },
            {
                name: 'guaranteed_rent_excluding_tax',
                label: 'Loyer garanti H.T.',
                type: 'number',
            },
            {
                name: 'full_ownership_amount',
                label: 'Prix Nu Propriété',
                type: 'number',
            },
            {
                name: 'recommended_market_rent_pk_included',
                label: 'Loyer marché recommandé Pk inclus',
                type: 'number',
            },
            {
                name: 'usufruct_duration',
                label: 'Durée d\'usufruit (années)',
                type: 'number',
            },
            {
                name: 'discount_rate',
                label: 'Taux décôte (%)',
                type: 'number',
            },
            {
                name: 'full_ownership_price',
                label: 'Loyer marché mensuel maxi ',
                type: 'number',
            },
            {
                name: 'garantee_rent',
                label: 'Loyer garanti TTC',
                type: 'number',
            },
        ];
    }
    defaultValue: any = {
        building: null,
        name: null,
        floor: null,
        type: null,
        type2: null,
        status: null,
        exposure: null,
        surface_carrez: null,
        surface_no_carrez: null,
        surface_terrace: null,
        surface_copro_garden: null,
        surface_land: null,
        rent_limit_pk_included: null,
        rent_limit_lgt_alone: null,
        rent_limit_pk_alone: null,
        price: null,
        amount_property: null,
        amount_work: null,
        amount_work_no_defisc: null,
        price_parking: null,
        price_parking_reduced_vat: null,
        selling_fee: null,
        location_amount_property: null,
        location_amount_furniture: null,
        location_amount_vat_back: null,
        rent_for_resseling: null,
        name_parking1: null,
        name_parking2: null,
        name_parking3: null,
        cat_parking1: null,
        cat_parking2: null,
        cat_parking3: null,
        surface_terrace_varangue: 0,
        price_reduced_brs: null,
        price_reduced_lli: null,
        prix_nue_propriete: null,
        price_vat_reduce_or_controlled: null,
        rent_limit_pinel: null,
        rent_limit_market: null,
        current_rent: null,
        guaranteed_rent_excluding_tax: null,
        full_ownership_amount: null,
        recommended_market_rent_pk_included: null,
        discount_rate: null,
        usufruct_duration: null,
        maximum_monthly_market_rent: null,
        garantee_rent: null,
        year_construction: null,
    };

    async created(): Promise<void> {
        this.loading = true;
        this.type = this.$route.name === 'addLot' ? 'add' : 'edit';
        if (this.type === 'edit' && this.lot) {
            this.defaultValue.name = this.lot.name || null;
            this.defaultValue.description = this.lot.description || null;
            this.defaultValue.type = this.lot.type || null;
            this.defaultValue.type2 = this.lot.type2 || null;
            this.defaultValue.surface_carrez = this.lot.surface_carrez || null;
            this.defaultValue.surface_no_carrez =
                this.lot.surface_no_carrez || null;
            this.defaultValue.surface_copro_garden =
                this.lot.surface_copro_garden || null;
            this.defaultValue.rent_limit_pk_included =
                this.lot.rent_limit_pk_included || null;
            this.defaultValue.rent_limit_pk_alone =
                this.lot.rent_limit_pk_alone || null;
            this.defaultValue.rent_limit_lgt_alone =
                this.lot.rent_limit_lgt_alone || null;
            this.defaultValue.amount_property =
                this.lot.amount_property || null;
            this.defaultValue.amount_work = this.lot.amount_work || null;
            this.defaultValue.amount_work_no_defisc =
                this.lot.amount_work_no_defisc || null;
            this.defaultValue.price_parking = this.lot.price_parking || null;
            this.defaultValue.price_parking_reduced_vat = this.lot.price_parking_reduced_vat || null;
            this.defaultValue.selling_fee = this.lot.selling_fee || null;
            this.defaultValue.location_amount_property =
                this.lot.location_amount_property || null;
            this.defaultValue.location_amount_furniture =
                this.lot.location_amount_furniture || null;
            this.defaultValue.location_amount_vat_back =
                this.lot.location_amount_vat_back || null;
            this.defaultValue.rent_for_resseling =
                this.lot.rent_for_resseling || null;
            this.defaultValue.name_parking1 = this.lot.name_parking1 || null;
            this.defaultValue.name_parking2 = this.lot.name_parking2 || null;
            this.defaultValue.name_parking3 = this.lot.name_parking3 || null;
            this.defaultValue.cat_parking1 = this.lot.cat_parking1 || null;
            this.defaultValue.cat_parking2 = this.lot.cat_parking2 || null;
            this.defaultValue.cat_parking3 = this.lot.cat_parking3 || null;
            this.defaultValue.surface_land = this.lot.surface_land || null;
            this.defaultValue.status = this.lot.status || null;
            this.defaultValue.building = this.lot.building || null;
            this.defaultValue.floor = this.lot.floor || null;
            this.defaultValue.exposure = this.lot.exposure || null;
            this.defaultValue.surface_terrace =
                this.lot.surface_terrace || null;
            this.defaultValue.price = this.lot.price || null;
            this.defaultValue.surface_terrace_varangue =
                this.lot.surface_terrace_varangue || 0;
            this.defaultValue.price_vat_reduce_or_controlled =
                this.lot.price_vat_reduce_or_controlled || null;
            this.defaultValue.price_reduced_brs =
                this.lot.price_reduced_brs || null;
                this.defaultValue.price_reduced_lli =
                this.lot.price_reduced_lli || null;
                this.defaultValue.prix_nue_propriete  =
                this.lot.prix_nue_propriete  || null;
            this.defaultValue.rent_limit_pinel =
                this.lot.rent_limit_pinel || null;
            this.defaultValue.rent_limit_market =
                this.lot.rent_limit_market || null;
            this.defaultValue.current_rent = this.lot.current_rent || null;
            this.defaultValue.guaranteed_rent_excluding_tax =
                this.lot.guaranteed_rent_excluding_tax || null;
            this.defaultValue.full_ownership_amount =
                this.lot.full_ownership_amount || null;
            this.defaultValue.recommended_market_rent_pk_included =
                this.lot.recommended_market_rent_pk_included || null;
            this.defaultValue.usufruct_duration =
                this.lot.usufruct_duration || null;
            this.defaultValue.discount_rate =
                this.lot.discount_rate || null;
            this.defaultValue.maximum_monthly_market_rent =
                this.lot.maximum_monthly_market_rent || null;
            this.defaultValue.garantee_rent = this.lot.garantee_rent || null;
            this.defaultValue.year_construction = (this.lot.year_construction && moment(this.lot.year_construction)) || null;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const program =
            this.type === 'add'
                ? +this.$route.params.programID
                : this.lot
                ? this.lot.program
                    ? this.lot.program.id
                    : -1
                : 0;
        const newLot: Lot = {
            // @ts-ignore
            program,
            name: form.name,
            description: form.description,
            type: form.type,
            type2: form.type2,
            surface_carrez: form.surface_carrez,
            surface_no_carrez: form.surface_no_carrez,
            surface_copro_garden: form.surface_copro_garden,
            rent_limit_pk_included: form.rent_limit_pk_included,
            rent_limit_pk_alone: form.rent_limit_pk_alone,
            rent_limit_lgt_alone: form.rent_limit_lgt_alone,
            amount_property: form.amount_property,
            amount_work: form.amount_work,
            amount_work_no_defisc: form.amount_work_no_defisc,
            price_parking: form.price_parking,
            price_parking_reduced_vat: form.price_parking_reduced_vat,
            selling_fee: form.selling_fee,
            location_amount_property: form.location_amount_property,
            location_amount_furniture: form.location_amount_furniture,
            location_amount_vat_back: form.location_amount_vat_back,
            rent_for_resseling: form.rent_for_resseling,
            name_parking1: form.name_parking1,
            name_parking2: form.name_parking2,
            name_parking3: form.name_parking3,
            cat_parking1: form.cat_parking1,
            cat_parking2: form.cat_parking2,
            cat_parking3: form.cat_parking3,
            surface_land: form.surface_land,
            status: form.status,
            building: form.building,
            floor: form.floor,
            exposure: form.exposure,
            surface_terrace: form.surface_terrace,
            price: form.price,
            surface_terrace_varangue: form.surface_terrace_varangue,
            price_vat_reduce_or_controlled: form.price_vat_reduce_or_controlled,
            price_reduced_brs: form.price_reduced_brs,
            price_reduced_lli: form.price_reduced_lli,
            prix_nue_propriete: form.prix_nue_propriete,
            rent_limit_pinel: form.rent_limit_pinel,
            rent_limit_market: form.rent_limit_market,
            current_rent: form.current_rent,
            guaranteed_rent_excluding_tax: form.guaranteed_rent_excluding_tax,
            full_ownership_amount: form.full_ownership_amount,
            recommended_market_rent_pk_included:
                form.recommended_market_rent_pk_included,
            usufruct_duration:
                form.usufruct_duration,
            discount_rate:
                form.discount_rate,
            maximum_monthly_market_rent: form.maximum_monthly_market_rent,
            year_construction: form.year_construction,
            garantee_rent: form.garantee_rent,
        };
        const $vs = (this as any).$vs;
        try {
            if (this.type === 'add') {
                await postLot(newLot).catch(errors => {
                    this.error = errors.response.data.message;
                });
                if (this.error) {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: this.error,
                    });
                    return;
                }
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Création',
                    text: `Création du lot réussie`,
                });
            } else {
                await patchLot(+this.$route.params.lotID, newLot).catch(
                    errors => {
                        this.error = errors.response.data.message;
                    }
                );
                if (this.error) {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: this.error,
                    });
                    return;
                }
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Modification',
                    text: `Modification du lot réussie`,
                });
            }
            this.$router.push({
                name: 'showProgram',
                params: {
                    programID: program ? program.toString() : '-1',
                },
            });
        } catch (error) {
            this.errors = error.response.data.errors.children;
            //console.log(this.error);
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }
}
